import Category from "../models/finance/Category";
import { CategoryType } from "../models/finance/CategoryType";
import CategoryRequest from "../models/request/CategoryRequest";
import {
  CATEGORIES_URL,
  CATEGORY_FALLBACK_QUERY_PARAM,
  CATEGORY_INCLUDE_INACTIVE_PARAM,
  CATEGORY_TYPE_QUERY_PARAM,
} from "../utils/constants/ApiConstants";
import { httpClient } from "./http/httpClient";
import { CategoryArraySchema, CategorySchema, validate } from "./schemas";

export async function getCategories(categoryType: CategoryType, includeInactive: boolean = false): Promise<Category[]> {
  const query = {
    [CATEGORY_TYPE_QUERY_PARAM]: categoryType,
    [CATEGORY_INCLUDE_INACTIVE_PARAM]: String(includeInactive),
  };
  const { data } = await httpClient.get<Category[]>(CATEGORIES_URL, { query, authenticated: true });
  return validate(CategoryArraySchema, data);
}

export async function createCategory(categoryTitle: string, categoryType: CategoryType): Promise<Category> {
  const payload: CategoryRequest = {
    title: categoryTitle,
    type: categoryType,
  };
  const { data } = await httpClient.post<Category, CategoryRequest>(CATEGORIES_URL, payload, { authenticated: true });
  return validate(CategorySchema, data);
}

export async function updateCategory(category: Category, newTitle?: string, newIsActive?: boolean): Promise<Category> {
  const url = `${CATEGORIES_URL}/${category.id}`;
  const updated: Category = {
    ...category,
    title: newTitle === undefined ? category.title : newTitle,
    isActive: newIsActive === undefined ? category.isActive : newIsActive,
  };
  const { data } = await httpClient.put<Category, Category>(url, updated, { authenticated: true });
  return validate(CategorySchema, data);
}

export async function deleteCategory(category: Category, fallbackCategoryId?: string): Promise<void> {
  const url = `${CATEGORIES_URL}/${category.id}`;
  const query = fallbackCategoryId ? { [CATEGORY_FALLBACK_QUERY_PARAM]: fallbackCategoryId } : undefined;
  await httpClient.delete<void>(url, { query, authenticated: true });
}


